<template>
    <div style="height:100%;">
        <div id="csContainer"></div>
    </div>
</template>

<script>
    import util from "../../components/util"

    export default {
        mounted() {
            this.init();
        },
        methods: {
            init() {
                let vw = util.getViewer("csContainer");
                this._loadBeijing(vw);
            },

            _loadBeijing(viewer) {
                //Seed the random number generator for repeatable results.
                Cesium.Math.setRandomNumberSeed(0);

                let promise = Cesium.GeoJsonDataSource.load('/demo/static/data/geojson/bj_region.geojson');
                promise.then(function (dataSource) {
                    viewer.dataSources.add(dataSource);

                    //Get the array of entities
                    let entities = dataSource.entities.values;

                    // let colorHash = {};
                    for (let i = 0; i < entities.length; i++) {
                        //For each entity, create a random color based on the state name.
                        //Some states have multiple entities, so we store the color in a
                        //hash so that we use the same color for the entire state.
                        let entity = entities[i];

                        let name = entity.name;
                        // let color = colorHash[name];
                        // if (!color) {
                        //     color = Cesium.Color.fromRandom({
                        //         alpha: 1.0
                        //     });
                        //     colorHash[name] = color;
                        // }
                        // //Set the polygon material to our random color.
                        // entity.polygon.material = color;

                        //Remove the outlines.
                        entity.polygon.outline = false;

                        //Extrude the polygon based on the state's population.  Each entity
                        //stores the properties for the GeoJSON feature it was created from
                        //Since the population is a huge number, we divide by 50.
                        // entity.polygon.extrudedHeight = entity.properties.Population / 50.0;
                        entity.polygon.extrudedHeight = 40000;
                    }
                    viewer.zoomTo(entities);
                }).otherwise(function (error) {
                    //Display any errrors encountered while loading.
                    window.alert(error);
                });
            }
        }
    }
</script>

<style scoped>
    #csContainer {
        height: 100%;
    }
</style>
